import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReceiptIcon from "@mui/icons-material/Receipt";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Order(props) {
  const orderDetails = props?.orderDetails;

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              style={{
                backgroundColor: "#6b469e",
                color: "white",
                height: "3vh",
              }}
              sx={{
                "&.Mui-expanded": {
                  minHeight: 0,
                },
                "&.MuiAccordionSummary-root": {
                  minHeight: 0,
                },
              }}
              expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
            >
              <Typography
                style={{
                  width: "100%",
                }}
              >
                <ReceiptIcon
                  style={{ marginRight: "1%", verticalAlign: "middle" }}
                />
                Order (Source: Raw SAP)
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table
                sx={{ minWidth: "30%" }}
                size="small"
                aria-label="serial number reference table"
              >
                <TableBody>
                  {orderDetails.map((row, i) => {
                    if (row?.value) {
                      return (
                        <TableRow>
                          <TableCell key={row.name + i + " namecell"}>
                            {row.name}
                          </TableCell>
                          <TableCell key={row.value + i + " valuecell"}>
                            {row.value}
                          </TableCell>
                        </TableRow>
                      );
                    } else {
                      return null;
                    }
                  })}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </TableContainer>
      </div>
    </React.Fragment>
  );
}
